import { render } from "./demo.vue?vue&type=template&id=de5d79e2"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"
script.render = render

export default script